<div class="cd-page">
  <!-- SIDEBAR -->
  <app-district-nav></app-district-nav>

  <!-- MAIN -->
  <main class="cd-main" aria-label="District Admin SIS Integration">
    <div>
      <div class="cd-title-box">
        <h1 class="cd-title">SIS Integration</h1>
        <button mat-flat-button (click)="openIntegrationDialog()">Manage Integration</button>
      </div>
      <p class="cd-subtitle">Sync roster data with your student information system</p>
    </div>

    <!-- Connection State-->
    <div class="connection-status" [ngClass]="'is-' + connectionState">
      <span class="status-dot"></span>
      <span class="status-label">{{ connectionStatusLabel }}</span>
    </div>

    <!-- Connection Info -->
    <div class="cd-card">
      <div class="cd-card-header">
        <div class="cd-field">
          <h4>Status</h4>
          <p>{{ integration().status }}</p>
        </div>
        <!-- <div class="cd-field">
          <h4>Provider</h4>
          <p>PowerSchool</p>
        </div> -->
        <div class="cd-field">
          <h4>Connection Type</h4>
          <p>{{ integration().type }}</p>
        </div>
        <div class="cd-field">
          <h4>Last Sync</h4>
          <p>Date</p>
        </div>
      </div>

      <div class="cd-card-footer connection-btns">
        <button
          mat-flat-button
          color="primary"
          (click)="manualSync()"
          [disabled]="integration().type === 'CSV'"
        >
          Sync
        </button>
        <button mat-flat-button (click)="editConnection()">Edit Connection</button>
      </div>
    </div>

    <!-- Connection Details -->

    @if (integration().type === 'API') {
      <div>
        <p class="cd-heading">Connection Details</p>
      </div>

      <div class="cd-card">
        <div class="cd-card-header">
          <!-- <div class="cd-field">
          <h4>Provider</h4>
          <p>PowerSchool</p>
        </div> -->
          <div class="cd-field">
            <h4>Base Url</h4>
            <p class="cd-value--mono">{{ integration().baseUrl }}</p>
          </div>
          <div class="cd-field">
            <h4>Client ID</h4>
            <p class="cd-value--mono">{{ integration().credentials?.clientId }}</p>
          </div>
          <div class="cd-field">
            <h4>Client Secret</h4>
            <div class="cd-secret">
              <p class="cd-value--mono">
                {{ secretRevealed ? integration().credentials?.clientSecret : maskedSecret }}
              </p>
              <button
                type="button"
                class="cd-secret-toggle"
                (click)="secretRevealed = !secretRevealed"
                [attr.aria-label]="secretRevealed ? 'Hide client secret' : 'Show client secret'"
              >
                <mat-icon>{{ secretRevealed ? 'visibility_off' : 'visibility' }}</mat-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
    }
    <!-- Synchronization -->

    <div>
      <p class="cd-heading">Synchronization</p>
    </div>

    <div class="cd-card">
      <div class="cd-card-header">
        <div class="cd-field">
          <h4>Last Sync Trigger</h4>
          <p>{{ lastSuccessful?.trigger }}</p>
        </div>
        <div class="cd-field">
          <h4>Last Successful Sync</h4>
          <p class="cd-value--mono">{{ lastSuccessful?.date }}</p>
        </div>
        @if (integration().type === 'API') {
          <div class="cd-field cd-field--wide">
            <h4>Sync History</h4>
            <ul class="cd-sync-history">
              @for (run of syncHistory; track run.success) {
                <li class="cd-sync-history__item">
                  <span class="cd-sync-icon" [ngClass]="run.success ? 'is-success' : 'is-failed'">
                    {{ run.success ? '✓' : '✕' }}
                  </span>
                  <span class="cd-sync-history__status">{{
                    run.success ? 'Success' : 'Failed'
                  }}</span>
                  <span class="cd-sync-history__trigger">{{ run.trigger }}</span>
                  <span class="cd-sync-history__date cd-value--mono">{{ run.date }}</span>
                </li>
              }
            </ul>
          </div>
        }
      </div>
    </div>

    <!-- Imported Data  -->
    <div>
      <p class="cd-heading">Imported Data</p>
    </div>

    <div class="cd-card">
      <div class="cd-card-header">
        <div class="cd-field">
          <h4>Schools</h4>
          <p>{{ integration().importedData?.schools }}</p>
        </div>
        <div class="cd-field">
          <h4>Faculty</h4>
          <p class="cd-value--mono">{{ integration().importedData?.faculty }}</p>
        </div>
        <div class="cd-field">
          <h4>Students</h4>
          <p class="cd-value--mono">{{ integration().importedData?.students }}</p>
        </div>
      </div>
    </div>
  </main>
</div>
